// extracted by mini-css-extract-plugin
module.exports = {"control-button":"containers-Dashboard-TasksAndChecklist-Controls__control-button--3cRG6"};